import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import {NgSelectizeModule} from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { WithdrawComponent } from './withdraw.component';
import { DirectiveModule } from '@bt/directives/directive.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgSelectizeModule,
    FontAwesomeModule,
    DirectiveModule
  ],
  entryComponents:[],
  declarations: [
    WithdrawComponent
  ],
})
export class WithdrawModule { }


// WEBPACK FOOTER //
// ./src/app/withdraw/withdraw.module.ts